import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { AuthorizeUserTree, assignmentTypes, assignmentPermissions } from '../../shared/authorization';
import { acceptedExcelFileExtensions } from '../../shared/fileUpload/constants';
import DropdownMenu from '../../shared/dropdownMenu';
import FileUploadButton from '../../shared/fileUpload/fileUploadButton.component';
import config from '../../config';

import { generateAssetPath } from '../../utils/assetsHelpers';

class HamburgerMenu extends PureComponent {
  static propTypes = {
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
    fileToImportChange: PropTypes.func.isRequired,
    templateFileName: PropTypes.string.isRequired,
  };

  hideDropdown = () => this.dropdown.hideDropDown();

  onFileUploadButtonChange = event => {
    this.props.fileToImportChange(event);
    event.target.value = '';
  };

  renderDownloadImportTemplate = () => (
    <AuthorizeUserTree
      withAssignments={[{
        assignmentType: assignmentTypes.CC,
        requiredPermission: assignmentPermissions.Adjust,
      }]}
    >
      <a
        className="hamburger-action"
        role="button"
        tabIndex="1"
        download={this.props.templateFileName}
        href={generateAssetPath(config.templates.BATCH_ADJUSTMENTS)}
        onClick={this.hideDropdown}
      >
        Download Import Template
      </a>
    </AuthorizeUserTree>
  );

  renderChooseFileToImport = () => (
    <FileUploadButton
      accept={acceptedExcelFileExtensions}
      className="upload-file-button hamburger-action"
      onChange={this.onFileUploadButtonChange}
      onClick={this.hideDropdown}
    >
      Choose File to Import
    </FileUploadButton>
  );

  render() {
    return (
      <DropdownMenu ref={dropdown => this.dropdown = dropdown} contentClassName="hamburger-menu">
        {this.renderDownloadImportTemplate()}
        {this.renderChooseFileToImport()}
      </DropdownMenu>
    );
  }
}

export default HamburgerMenu;
